import { LotChannelLastPayload } from '../../store/channelState/channelState'
import { UserLot } from '../../store/userState/userState'
import { CurrentBid } from '../CurrentBid/CurrentBid'
import { MaxBid } from '../MaxBid/MaxBid'
import { StartingBid } from '../StartingBid/StartingBid'
import { StyledOutbidLabel, StyledWinningBid } from './BidStatus.styles'

export const BidStatus = ({
  userLotData,
  biddingEvent,
  currencySymbol,
  isWinningBidder,
  showOutbidMessage,
}: BidStatusProps) => {
  if (
    (!userLotData || !userLotData.hasActiveBid || !userLotData.bidAmount) &&
    !!biddingEvent.currentBid
  ) {
    return (
      <CurrentBid
        currencySymbol={currencySymbol}
        price={biddingEvent.currentBid}
      />
    )
  }

  if ('startingPrice' in biddingEvent && !biddingEvent.currentBid) {
    return (
      <StartingBid
        currencySymbol={currencySymbol}
        price={biddingEvent.startingPrice}
      />
    )
  }

  if (isWinningBidder && biddingEvent.currentBid) {
    return (
      <>
        <StyledWinningBid
          currencySymbol={currencySymbol}
          price={biddingEvent.currentBid}
        />
        {userLotData?.bidAmount &&
          biddingEvent.currentBid &&
          userLotData.bidAmount > biddingEvent.currentBid && (
            <MaxBid
              currencySymbol={currencySymbol}
              price={userLotData.bidAmount}
            />
          )}
      </>
    )
  }

  if (showOutbidMessage && biddingEvent.currentBid) {
    return (
      <CurrentBid
        currencySymbol={currencySymbol}
        price={biddingEvent.currentBid}
        isOutbid
      />
    )
  }

  if (biddingEvent.currentBid) {
    return (
      <StyledOutbidLabel
        currencySymbol={currencySymbol}
        price={biddingEvent.currentBid}
      />
    )
  }

  return null
}

interface BidStatusProps {
  userLotData?: UserLot
  biddingEvent: NonNullable<LotChannelLastPayload>
  currencySymbol: string
  isWinningBidder?: boolean
  showOutbidMessage?: boolean
}
